<template>
  <component :is="componentName" :menu-obj="items" :messages="messages" />
</template>

<script>
import { mapState } from 'vuex';
import MenuMobileCatalog from '@components/Menus/MenuMobileCatalog.vue';
import VueMenuDesktop from '@components/Menus/VueMenu/VueMenuDesktop.vue';
import { screenWidth } from '@use/useDeviceInfo';

export default {
  name: 'VueMenu',
  components: {
    MenuMobileCatalog,
    VueMenuDesktop,
  },
  data() {
    return {
      menu: this.result,
      screenWidth,
    };
  },
  computed: {
    ...mapState({
      items: ({ results }) => results?.menus?.mainMenu.items,
      messages: ({ results }) => results?.messages,
    }),
    componentName() {
      return this.screenWidth < 992 ? 'MenuMobileCatalog' : 'VueMenuDesktop';
    },
  },
};
</script>
